export default __webpack_public_path__ + "static/media/HelveticaNeue Medium.64ab5024.ttf";